/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgTailWorker = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.22 12.305-3.198-4.3 3.181-4.178-.614-.842-3.584 4.713L2 8.3l3.601 4.848.62-.843Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.337 2h-1.23l4.439 6.1L6.21 14h1.238l4.333-5.898L7.337 2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.717 2H8.471l4.51 6.027L8.47 14h1.25L14 8.33v-.603L9.717 2ZM7.4 6h1v3.5h-1zM6.2 7h1v2.5h-1zM5 8h1v1.5H5z"
}));

export default SvgTailWorker;